module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100 container-fluid"
  }, [_c('div', {
    staticClass: "h-100 row"
  }, [_c('div', {
    staticClass: "h-100 col-12 main",
    class: {
      'col-sm-8 col-xl-9': _vm.showSidebar
    },
    style: ({
      'backgroundColor': 'hsl(0, 0%, ' + _vm.settings.backgroundColor + '%)'
    })
  }, [_c('viewport', {
    attrs: {
      "dataCanvas": _vm.dataCanvas
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'sidebar h-100 col-12 col-sm-4 col-xl-3': _vm.showSidebar
    }
  }, [_c('div', {
    staticClass: "settingsToggle"
  }, [_c('a', {
    staticClass: "icon fa",
    class: _vm.showSidebar ? 'fa-times' : 'fa-sliders',
    on: {
      "click": _vm.settingsToggle
    }
  })]), _vm._v(" "), (_vm.showSidebar) ? _c('settings', {
    attrs: {
      "settings": _vm.settings,
      "dataCanvas": _vm.dataCanvas
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70745af6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 32
// module chunks = 0